import React, {Component} from 'react';
import {Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import Notify from 'react-notification-alert';
import {filterServices, showAxiosError, xsltTypeList, xsltTypeMap} from "../../../helper/helper";
import {request} from "../../../helper/APIUtils";
import Select from "../../../local_node_modules/react-select"
import {EntegratorConf} from "../../../constants";
import {EntegratorIdentifiers} from "../../../helper/enums";

class XsltCreateModal extends Component {


	constructor(props) {
		super(props);
		this.state =
			{
				modal: false,
				openMode: undefined,
				xslt: undefined,
				uploading:false,
				xsltTypeMap:xsltTypeMap,
				serviceList:[]
			};

		this.save = this.save.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
		this.editHandleInputChange = this.editHandleInputChange.bind(this);
		this.isDefaultChecked = this.isDefaultChecked.bind(this);
	}

	componentDidMount() {
		let mode = '';
		let xslt = this.props.xslt;
		let serviceList = this.props.serviceList;
		let nextState = {
			modal: this.props.modal,
			openMode: mode,
			xslt: xslt,
			typeList: xsltTypeList(),
			serviceList: serviceList
		};

		this.setState(nextState);
	}
	componentDidUpdate(prevProps, prevState) {
		if (EntegratorConf.identifier === EntegratorIdentifiers.ZIRVE &&
			this.state !== prevState) {
			this.isDefaultChecked();
		}
	}


	toggleModal() {
		this.props.listener();
	}

	save() {
		const mode = this.state.openMode;
		let self = this;
		let {filename, type,} = this.state.xslt;
		let errorMessage ="", showError = false;

		if(!filename){
			errorMessage = "XSLT Adı boş bırakılamaz."
			showError = true;
		}
		if(!type){
			errorMessage = "XSLT Türü seçilmesi zorunludur."
			showError = true;
		}

		if(showError){
			this.refs.notify.notificationAlert({
				place: 'tr',
				message: errorMessage,
				type: 'danger',
				autoDismiss: 10,
			});
			return;
		}

		let params = this.createRequestParams();
		this.setState({uploading: true});
		request(params).then(function (response) {
			self.setState({
				uploading: false,
			});
		self.props.listener();
		self.props.goToListPage();
		}).catch(function (error) {
			self.setState({uploading: false});
			showAxiosError(error);
		});

	}

	createRequestParams(){

		let formData = new FormData();
		let customerId = this.props.customerId === undefined ? 0 : this.props.customerId;

		formData.append("type", this.state.xslt.type);
		formData.append("filename", this.state.xslt.filename);
		formData.append("default", this.state.xslt.isDefault);
		let fileContent = new Blob([this.state.xslt.content], { type: 'application/xml' })
		formData.append("content", fileContent);
		formData.append("attributes", JSON.stringify(this.state.xslt.attributes));
		formData.append("customerId", customerId === null ? 0 : customerId);

		let params = {
			url: 	(this.state.xslt.id===null)?"/xslt/upload":"/xslt/update/"+this.state.xslt.id,
			method : 'post',
			data : formData
		};

		console.log("params",params);
		return params;

	}
	editHandleInputChange(event) {
		const target = event.target;
		const value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
		const name = target.name;

		let xslt = this.state.xslt;
		xslt[name] = value;
		this.setState({xslt});
	}
	isDefaultChecked() {
		let formData = new FormData();
		let customerId = this.props.customerId === undefined ? 0 : this.props.customerId;

		formData.append("type", this.state.xslt.type);
		formData.append("customerId", customerId === null ? 0 : customerId);

			let params = {
				url: "/xslt/isDefaultXslt",
				method: 'post',
				data: formData
			};

		request(params)
			.then(response => {
				const checkXslt = response.data;
				if (checkXslt === true) {
					this.setState({isDefault: checkXslt});
				}
			})
			.catch(error => {
				console.error(error);
			});
	}


	render() {

		let allServices=[];
		allServices=filterServices(this.state.xsltTypeMap,this.state.serviceList);
		return (
			<Modal isOpen={this.state.modal} size="lg">
				<Notify ref="notify"/>
				<ModalHeader toggle={this.toggleModal}>XSLT Oluştur</ModalHeader>
				<ModalBody>
					{this.state.uploading && <div className="row"><span className="pull-right" >Processing..</span></div>}
					{this.state.xslt &&
					<Form>
						<FormGroup row>
							<Label sm={4}>XSLT Türü</Label>
							<Col sm={8}>
								<Select
									wrapperStyle={{position:'relative', zIndex: 9999}}
									clearable={false}
									searchable={false}
									className="select-control"
									value={this.state.xslt.type}
									disabled={true}
									placeholder="Seçiniz..."
									//options={this.state.typeList.map((type) => ({value: type, label: xsltTypeLabel(type)}))}
									options={allServices&&Array.isArray(allServices)&&allServices.map((type) => ({value: type.value, label: type.label}))}

								/>
							</Col>
						</FormGroup>
						<FormGroup row>
							<Label sm={4}>XSLT Adı</Label>
							<Col sm={8}>
								<Input type="text" name="filename" value={this.state.xslt.filename}
									   onChange={this.editHandleInputChange}/>
							</Col>
						</FormGroup>
							<FormGroup row>
								<Label sm={4}>Varsayılan olarak kullanılsın</Label>
								<Col sm={8}>
									<Input type="checkbox" name="isDefault" checked={this.state.isDefault}
										   onChange={this.editHandleInputChange}/>
								</Col>
							</FormGroup>
					</Form>
					}
				</ModalBody>
				<ModalFooter>
					<button type="button" onClick={this.toggleModal}
							style={{background:' linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))', padding:'9px 45px 9px 20px'}}
							className="TekBtn vazgec">Kapat
					</button>
					<button type="button" disabled={this.state.uploading} onClick={this.save} style={{padding:'9px 45px 9px 20px'}} className=" TekBtn kaydet pull-right">Kaydet
					</button>
				</ModalFooter>
			</Modal>
		)
	}
}


export default XsltCreateModal;



